import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Ribbon from "@/components/Ribbon";
import Packages from "@/components/Packages";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import { useLenis, scrollToTarget } from "@/components/LenisProvider";

export default function Landing() {
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");
  const lenis = useLenis();

  useEffect(() => {
    api
      .get("/packages")
      .then((r) => setPackages(r.data))
      .catch(() => setPackages([]));
  }, []);

  const handleSelectPackage = (pkgId) => {
    setSelectedPackage(pkgId);
    setTimeout(() => scrollToTarget(lenis, "#booking"), 60);
  };

  return (
    <main className="bg-[#090909] min-h-screen">
      <Nav />
      <Hero />
      <Ribbon />
      <Packages packages={packages} onSelect={handleSelectPackage} />
      <Gallery />
      <About />
      <Testimonials />
      <Faq />
      <BookingForm
        packages={packages}
        selectedPackage={selectedPackage}
        onPackageChange={setSelectedPackage}
      />
      <Footer />
    </main>
  );
}
